import React, { useState, Fragment, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select, Table, DatePicker, Checkbox, Popconfirm, notification,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import SelectSeller from '@Components/Common/SelectSeller';
import Helpers from '@Apis/helpers';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import SoActions from '@Actions/sales/soActions';
import CartActions from '@Actions/cartActions';
import SelectAppUser from '@Components/Common/SelectAppUser';
import './style.scss';
import Crown from '@Images/crown2.png';
import { QUANTITY } from '@Apis/constants';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

const ConvertCartToMo = ({
  callback, user, convertSoToMoLoading, convertSoToMo, selectedRows, inputTenant, getSKUAvailability, getSKUAvailabilityLoading, isMrp, skuQtyMap,
}) => {
  const [moLines, setMoLines] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [fgSelectedDepartment, setFgSelectedDepartment] = useState('');
  const [rmSelectedDepartment, setRmSelectedDepartment] = useState('');
  const [bpSelectedDepartment, setBpSelectedDepartment] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [scheduledDateCheckBox, setScheduledDateCheckBox] = useState(true);
  const [restrictMoUser, setRestrictMoUser] = useState(false);
  const [restrictionCheck, setRestrictionCheck] = useState(true);
  const [moUsers, setMoUsers] = useState([]);
  const [scheduledDate, setScheduledDate] = useState(dayjs());
  const isExcessMoAllowed = user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.settings?.allow_manufacturing_order_more_than_sales_order;

  const bomUserPermission = (skuLines) => {
    let restrictAccesss = [];

    for (let i = 0; i < skuLines?.length; i++) {
      const soLine = skuLines[i];
      if (soLine?.bom_list?.filter((item) => !filterRestrictedBom(item))?.length) {
        const selectedBom = soLine?.bom_list?.filter((item) => !filterRestrictedBom(item))?.find((item) => item?.is_active) || soLine?.bom_list?.filter((item) => !filterRestrictedBom(item))[0];
        if (selectedBom?.bom_users === null || selectedBom?.bom_users.includes(user?.user_id)) {
          if (selectedBom?.bom_users?.length) {
            restrictAccesss = [...restrictAccesss, ...selectedBom?.bom_users];
          }
        }
      }
    }
    setMoUsers(restrictAccesss);
  };

  const filterRestrictedBom = (item) => {
    if ((item?.is_restricted && item?.bom_users.includes(user?.user_id)) || (!item?.is_restricted && item?.bom_users === null)) {
      return false;
    } return true;
  };

  useEffect(() => {
    if ((selectedRows)) {
      const tenantId = selectedTenant || user?.tenant_info?.tenant_id;
      const tdId = selectedDepartment || user?.user_tenants?.find((item) => item?.tenant_id === tenantId)?.default_department_for_fg;
      setSelectedTenant(tenantId);
      setSelectedDepartment(tdId);
      setFgSelectedDepartment(user?.user_tenants?.find((item) => item?.tenant_id === tenantId)?.default_department_for_fg);
      setRmSelectedDepartment(user?.user_tenants?.find((item) => item?.tenant_id === tenantId)?.default_department_for_rm);
      setBpSelectedDepartment(user?.user_tenants?.find((item) => item?.tenant_id === tenantId)?.default_department_for_bp);
      const skuLinesPayload = {
        productSkuIds: selectedRows?.join(','),
        tenantId,
      };
      getSKUAvailability(skuLinesPayload, (skuLines) => {
        const lines = [];
        const noBom = [];
        for (let i = 0; i < skuLines?.length; i++) {
          const skuLine = skuLines[i];
          // const qty = (Number(skuLine?.so_quantity) * skuLine?.so_uom_info?.[0]?.ratio) / skuLine?.product_uom_info?.ratio;
          const tempLine = {
            key: uuidv4(),
            scheduledDate,
            deliveryDate: dayjs(scheduledDate).isBefore(skuLine?.delivery_date) ? skuLine?.delivery_date : scheduledDate,
            tenantDepartmentId: selectedDepartment,
            fgTenantProductId: skuLine?.tenant_product_id,
            quantity: skuQtyMap[skuLine?.product_sku_id] ?? 0,
            // soQuantity: isMrp ? skuLine?.demand_quantity : qty,
            uomId: skuLine?.product_uom_info?.uom_id,
            uomInfo: skuLine?.product_uom_info,
            // sentForProduction: skuLine?.total_fg_to_be_produced,
            // actualFgQuantity: skuLine?.actual_fg_produced,
            availableQuantity: skuLine?.available_quantity > 0 ? skuLine?.available_quantity : 0,
            skuLineId: skuLine?.order_line_id,
            soId: skuLine?.order_id,
            orderDate: skuLine?.order_date,
            soNumber: skuLine?.sales_order_number,
            productSkuName: skuLine?.product_sku_name,
            productSkuId: skuLine?.product_sku_id,
            refProductCode: skuLine?.ref_product_code,
            internalSkuCode: skuLine?.internal_sku_code,
            tenantName: skuLine?.so_tenant_name,
            job_works_type: 'batch_level',
            // mrp_id: skuLine?.mrp_id,
            remarks: skuLine?.remarks,
          };
          if (skuLine?.bom_list?.filter((item) => !filterRestrictedBom(item))?.length) {
            const selectedBom = skuLine?.bom_list?.filter((item) => !filterRestrictedBom(item))?.find((item) => item?.is_active) || skuLine?.bom_list?.filter((item) => !filterRestrictedBom(item))[0];
            lines.push({
              ...tempLine,
              bomList: skuLine?.bom_list?.filter((item) => !filterRestrictedBom(item)),
              selectedBom: selectedBom?.bom_id,
              enableWastageTracking: selectedBom?.enable_wastage_tracking ? 'YES' : 'NO',
            });
            setRestrictMoUser(accessRestriction ? !!((restrictionCheck && selectedBom?.bom_users?.length > 0)) : false);
          } else {
            noBom.push(tempLine);
          }
        }
        bomUserPermission(skuLines);
        setMoLines([...lines, ...noBom]);
      });
    }
  }, [selectedDepartment]);

  const updateData = (key, label, value) => {
    const tempMoLines = JSON.parse(JSON.stringify(moLines));
    for (let i = 0; i < tempMoLines?.length; i++) {
      if (tempMoLines[i]?.key === key) {
        tempMoLines[i][label] = value;
        break;
      }
    }
    setMoLines(tempMoLines);
  };

  const isDataValid = () => {
    const erroredLines = moLines.filter((line) => line.quantity === 0);
    let _isDataValid = true;
    _isDataValid = !(erroredLines.length > 0);
    return _isDataValid;
  };

  const onSubmit = () => {
    setFormSubmitted(true);
    const fgList = [];
    const tempMoLines = moLines?.filter((item) => item?.bomList);
    for (let i = 0; i < tempMoLines?.length; i++) {
      fgList.push({
        tenant_id: selectedTenant,
        is_restricted: restrictMoUser,
        mo_users: restrictMoUser ? moUsers : null,
        org_id: user?.tenant_info?.org_id,
        bom_id: tempMoLines[i]?.selectedBom,
        scheduled_date: tempMoLines[i]?.scheduledDate,
        delivery_date: tempMoLines[i]?.deliveryDate,
        enable_wastage_tracking: tempMoLines[i]?.enableWastageTracking === 'YES',
        job_works_type: tempMoLines[i]?.job_works_type,
        tenant_department_id: selectedDepartment,
        fg_tenant_department_id: Number(fgSelectedDepartment),
        rm_tenant_department_id: Number(rmSelectedDepartment),
        bp_tenant_department_id: Number(bpSelectedDepartment),
        tenant_seller_id: tempMoLines[i]?.tenantSellerId,
        seller_name: tempMoLines[i]?.sellerName,
        seller_address: tempMoLines[i]?.sellerAddress,
        seller_gst: tempMoLines[i]?.sellerGst,
        fg_tenant_product_id: tempMoLines[i]?.fgTenantProductId,
        quantity: tempMoLines[i]?.quantity,
        uom_id: tempMoLines[i]?.uomId,
        uom_info: tempMoLines[i]?.uomInfo,
        source: 'CART',
      });
    }
    if (fgList?.find((item) => Number(item?.quantity) <= 0)) {
      notification.open({
        message: 'Please enter a valid quantity for creating manufacturing orders',
        duration: 4,
        placement: 'top',
        type: 'warning',
      });
    } else if (!isExcessMoAllowed && !isDataValid()) {
      notification.open({
        message: 'Manufacturing quantity cannot exceed sales quantity.',
        duration: 4,
        placement: 'top',
        type: 'error',
      });
    } else {
      const payload = {
        mo_type: 'MULTIPLE',
        fg_list: fgList,
      };
      convertSoToMo(payload, () => {
        callback();
        setFormSubmitted(false);
      });
    }
  };

  const getTableColumns = () => {
    const columns = [
      {
        title: 'PRODUCT',
        width: '200px',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => (
          <Fragment>
            <Link to={`/inventory/product/view/${item?.productSkuId}?tab=1`} target="_blank">
              <H3Text text={`#${item?.internalSkuCode}`} />
            </Link>
            {item?.productSkuName}
            <div
                dangerouslySetInnerHTML={{ __html: item?.remarks }}
                className="table-subscript-grey"
                style={{
                  whiteSpace: 'pre-wrap',
                  marginTop: '5px',
                }}
              />
          </Fragment>
        ),
      },
      {
        title: 'TO BE PRODUCED',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        width: '140px',
        render: (record) => (
          <div>
            {
              record?.bomList?.length ? (
                <Fragment>
                  <div className="table-input-v2__wrapper table-input-v2__wrapper-long">
                    <H3Text text="Available Stock" className="table-input-v2__input-label" />
                    <H3Text text={`${QUANTITY(record?.availableQuantity, record?.uomInfo?.precision)} ${record?.uomInfo?.uqc?.toProperCase()}`} className="table-input-v2__input-value" />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      <H3FormInput
                        value={record.quantity}
                        name="quantity less than pending quantity"
                        type="number"
                        label="Quantity"
                        containerClassName={`table-input-v2__wrapper table-input-v2__wrapper-long table-input-v2__wrapper-flexible`}
                        labelClassName="table-input-v2__input-label"
                        inputClassName="orgFormInput"
                        onChange={(e) => updateData(record?.key, 'quantity', e.target.value)}
                      />
                    </div>
                    <div style={{ marginLeft: '5px' }}>
                      {record?.uomInfo?.uqc?.toProperCase()}
                    </div>
                  </div>
                  <div className="table-input-v2__wrapper">
                    <Checkbox
                      checked={record?.enableWastageTracking === 'YES'}
                      onChange={() => {
                        const value = record?.enableWastageTracking === 'YES' ? 'NO' : 'YES';
                        updateData(record?.key, 'enableWastageTracking', value);
                      }}
                    >
                      Enable Wastage Tracking
                    </Checkbox>
                  </div>
                </Fragment>
              ) : ''
            }
          </div>
        ),
      },
      {
        title: 'PRODUCTION DETAILS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <div>
            {
              record?.bomList?.length ? (
                <Fragment>
                  <div className="table-input-v2__wrapper">
                    <H3Text text="Bill of Material" className="table-input-v2__input-label" />
                    &nbsp;
                    <PRZSelect
                      value={record?.selectedBom}
                      filterOption={false}
                      onChange={(value) => {
                        const tempMoLines = JSON.parse(JSON.stringify(moLines));
                        for (let i = 0; i < tempMoLines?.length; i++) {
                          if (tempMoLines[i]?.key === record?.key) {
                            tempMoLines[i].selectedBom = value;
                            tempMoLines[i].enableWastageTracking = record?.bomList?.find((item) => item?.bom_id == value)?.enable_wastage_tracking ? 'YES' : 'NO';
                            break;
                          }
                        }
                        setMoUsers([...new Set([...moUsers, ...(value?.bom_users?.length > 0 ? value.bom_users : [])])]);
                        setRestrictionCheck(!!((restrictionCheck && value?.bom_users?.length > 0)));
                        setMoLines(tempMoLines);
                      }}
                    >
                      {
                        record?.bomList?.map((item) => (
                          <Option key={item?.bom_id} value={item?.bom_id}>
                            {`${item?.bom_number} -  ${item?.bom_alias_name}`}
                          </Option>
                        ))
                      }
                    </PRZSelect>
                  </div>
                  <div className="table-input-v2__wrapper">
                    <H3Text text="Scheduled Date" className="table-input-v2__input-label" />
                    &nbsp;
                    <DatePicker
                      value={dayjs(record?.scheduledDate)}
                      onChange={(value) => {
                        updateData(record?.key, 'scheduledDate', value);
                      }}
                      format="DD-MMM-YYYY"
                      style={{
                        border: '1px solid rgba(68, 130, 218, 0.2)',
                        borderRadius: '2px',
                        height: '32px',
                        padding: '1px 3px',
                        background: 'white',
                      }}
                      allowClear={false}
                      disabled={scheduledDateCheckBox}
                    />
                  </div>
                  <div className="table-input-v2__wrapper">
                    <H3Text text="Completion Date" className="table-input-v2__input-label" />
                    &nbsp;
                    <DatePicker
                      value={dayjs(record?.deliveryDate)}
                      onChange={(value) => {
                        updateData(record?.key, 'deliveryDate', value);
                      }}
                      format="DD-MMM-YYYY"
                      style={{
                        border: '1px solid rgba(68, 130, 218, 0.2)',
                        borderRadius: '2px',
                        height: '32px',
                        padding: '1px 3px',
                        background: 'white',
                      }}
                      allowClear={false}
                      disabledDate={(current) => current < dayjs().startOf('day')}
                    />
                  </div>
                  <div className="table-input-v2__wrapper">
                    <H3Text text="Subcontractor" className="table-input-v2__input-label" />
                    &nbsp;
                    <SelectSeller
                      onChange={(value) => {
                        const tempMoLines = JSON.parse(JSON.stringify(moLines));
                        for (let i = 0; i < tempMoLines?.length; i++) {
                          if (tempMoLines[i]?.key === record?.key) {
                            tempMoLines[i].tenantSellerId = value?.tenant_seller_id;
                            tempMoLines[i].sellerName = value?.seller_info?.seller_name;
                            tempMoLines[i].sellerAddress = value?.seller_info?.office_address_details;
                            tempMoLines[i].sellerGst = value?.seller_info?.gst_number;
                            break;
                          }
                        }
                        setMoLines(tempMoLines);
                      }}
                      inputClassName="XXXDONOTREMOVE"
                      selectedSeller={record?.tenantSellerId}
                      tenantId={selectedTenant}
                      showAddVendor={false}
                      notRequired
                      isSubcontractor
                      hideTitle
                      customStyle={{
                        border: 'none !important',
                      }}
                    />
                  </div>
                </Fragment>
              ) : <H3Text text="BOM NOT AVAILABLE" className="so-mo-table__no-info" />
            }
          </div>
        ),
      },
      {
        title: '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => (
          <div>
            {
              record?.bomList ? (
                <Popconfirm
                  title="Are you sure you want to remove this item?"
                  onConfirm={() => {
                    setMoLines(moLines?.filter((item) => item?.key !== record?.key));
                  }}
                >
                  <div className="delete-line-button__new">
                    <FontAwesomeIcon icon={faTrashCan} />
                  </div>
                </Popconfirm>
              ) : (
                <div className="delete-line-button__new" onClick={() => setMoLines(moLines?.filter((item) => item?.key !== record?.key))}>
                  <FontAwesomeIcon icon={faTrashCan} />
                </div>
              )
            }
          </div>
        ),
      },
    ];
    return columns;
  };

  const accessRestriction = user?.tenant_info?.production_config?.addons?.access_restriction?.is_active;
  const manufacturingOrder = user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.is_active;

  return (
    <Fragment>
      <div className="create-so-mo__wrapper" style={{ marginBottom: '40px' }}>
        <div className="ant-row">
          <div className="ant-col-md-8">
            <div className="create-so-mo__row">
              <H3Text required text="Select Location to Create Manufacturing Order" className="create-so-mo__row-label" />
              <TenantSelector
                selectedTenant={selectedTenant}
                showSearch
                onChange={(value) => {
                  setSelectedTenant(value);
                  setSelectedDepartment(user?.user_tenants?.find((item) => item?.tenant_id == value)?.default_department_for_production);
                  setFgSelectedDepartment(user?.user_tenants?.find((item) => item?.tenant_id === value)?.default_department_for_fg);
                  setRmSelectedDepartment(user?.user_tenants?.find((item) => item?.tenant_id === value)?.default_department_for_rm);
                  setBpSelectedDepartment(user?.user_tenants?.find((item) => item?.tenant_id === value)?.default_department_for_bp);
                }}
                placeholder="Select Business Unit"
                inputClassName="orgInputContainer"
                customStyle={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '4px',
                  width: '98%',
                  fontSize: '13px',
                }}
                hideTitle
                disabled={convertSoToMoLoading || getSKUAvailabilityLoading || isMrp}
                loading={getSKUAvailabilityLoading}
                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ)}
              />
            </div>
          </div>
          <div className="ant-col-md-8">
            <div className="create-so-mo__row">
              <H3Text required text="Department for Production" className="create-so-mo__row-label" />
              <SelectDepartment
                hideTitle
                tenantId={isMrp ? inputTenant : selectedTenant}
                tenentLevelDepartment
                selectedDepartment={Number(selectedDepartment) || ''}
                noDropdownAlign
                onChange={(value) => {
                  setSelectedDepartment(value?.tenant_department_id.toString() || '');
                }}
                emptyNotAllowed
                disabled={convertSoToMoLoading || getSKUAvailabilityLoading}
                customStyle={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '4px',
                  width: '98%',
                  fontSize: '13px',
                  marginBottom: '10px',
                }}
                loading={getSKUAvailabilityLoading}
              />
            </div>
          </div>
          <div className="ant-col-md-8">
            <div className="create-so-mo__row">
              <H3Text required text="Department for Raw Materials" className="create-so-mo__row-label" />
              <SelectDepartment
                hideTitle
                tenantId={isMrp ? inputTenant : selectedTenant}
                tenentLevelDepartment
                selectedDepartment={Number(rmSelectedDepartment) || ''}
                noDropdownAlign
                onChange={(value) => {
                  setRmSelectedDepartment(value?.tenant_department_id.toString() || '');
                }}
                emptyNotAllowed
                disabled={convertSoToMoLoading || getSKUAvailabilityLoading}
                customStyle={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '4px',
                  width: '98%',
                  fontSize: '13px',
                  marginBottom: '10px',
                }}
                loading={getSKUAvailabilityLoading}
              />
            </div>
          </div>
          <div className="ant-col-md-8">
            <div className="create-so-mo__row">
              <H3Text required text="Department for Finished Goods" className="create-so-mo__row-label" />
              <SelectDepartment
                hideTitle
                tenantId={isMrp ? inputTenant : selectedTenant}
                tenentLevelDepartment
                selectedDepartment={Number(fgSelectedDepartment) || ''}
                noDropdownAlign
                onChange={(value) => {
                  setFgSelectedDepartment(value?.tenant_department_id.toString() || '');
                }}
                emptyNotAllowed
                disabled={convertSoToMoLoading || getSKUAvailabilityLoading}
                customStyle={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '4px',
                  width: '98%',
                  fontSize: '13px',
                  marginBottom: '10px',
                }}
                loading={getSKUAvailabilityLoading}
              />
            </div>
          </div>
          <div className="ant-col-md-8">
            <div className="create-so-mo__row">
              <H3Text required text="Department for By Products" className="create-so-mo__row-label" />
              <SelectDepartment
                hideTitle
                tenantId={isMrp ? inputTenant : selectedTenant}
                tenentLevelDepartment
                selectedDepartment={Number(bpSelectedDepartment) || ''}
                noDropdownAlign
                onChange={(value) => {
                  setBpSelectedDepartment(value?.tenant_department_id.toString() || '');
                }}
                emptyNotAllowed
                disabled={convertSoToMoLoading || getSKUAvailabilityLoading}
                customStyle={{
                  border: '1px solid rgba(68, 130, 218, 0.2)',
                  borderRadius: '4px',
                  width: '98%',
                  fontSize: '13px',
                  marginBottom: '10px',
                }}
                loading={getSKUAvailabilityLoading}
              />
            </div>
          </div>
          <div className="ant-col-md-8" />
          <div className="ant-col-md-8">
            <div className="create-so-mo__row">
              <Checkbox
                checked={scheduledDateCheckBox}
                onChange={(e) => {
                  setScheduledDateCheckBox(e.target.checked);
                }}
                disabled={convertSoToMoLoading || getSKUAvailabilityLoading}
                style={{ margin: '-5px 0px 2px 0px' }}
              >
                <H3Text text="Use Same Scheduled Date for All Items" className="create-so-mo__row-label" />
              </Checkbox>
              {scheduledDateCheckBox && (
                <React.Fragment>
                  <DatePicker
                    value={dayjs(scheduledDate)}
                    format="DD-MMM-YYYY"
                    onChange={(date, dateString) => {
                      // Handle the selected date as needed
                      setScheduledDate(dateString);
                      // update the key in the moLines
                      const tempMoLines = JSON.parse(JSON.stringify(moLines));
                      for (let i = 0; i < tempMoLines?.length; i++) {
                        tempMoLines[i].scheduledDate = dateString;
                      }
                      setMoLines(tempMoLines);
                    }}
                    style={{
                      border: '1px solid rgba(68, 130, 218, 0.2)',
                      borderRadius: '4px',
                      height: '32px',
                      width: '98%',
                      background: 'white',
                      margin: '0px 0px 10px 0px',
                    }}
                  />
                </React.Fragment>
              )}
            </div>
          </div>
          <div className="ant-col-md-8">
            <div className="create-so-mo__row">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  checked={restrictMoUser}
                  onChange={(e) => {
                    setRestrictMoUser(e.target.checked);
                    setRestrictionCheck(e.target.checked !== false);
                  }}
                  disabled={convertSoToMoLoading || getSKUAvailabilityLoading || !accessRestriction}
                  style={{ margin: '-5px 0px 2px 0px' }}
                >
                  <H3Text text="Restrict Access" className="create-so-mo__row-label" />
                </Checkbox>
                {!accessRestriction && (
                  <Popconfirm
                    placement="topRight"
                    title="This feature is not available in your current plan"
                    onConfirm={() => window.Intercom('showNewMessage')}
                    okText="Contact Us"
                    cancelText="Cancel"
                  >
                    <img className="create-so-mo__row-premium-img" src={Crown} alt="premium" />
                  </Popconfirm>
                )}
              </div>
              {restrictMoUser && (
                <Fragment>
                  <div style={{ marginBottom: '12px' }}>
                    <div className="mo-form__input-row__input">
                      <SelectAppUser
                        hideTitle
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        selectedUser={moUsers}
                        onChange={(value) => setMoUsers(value)}
                        disabled={convertSoToMoLoading || getSKUAvailabilityLoading}
                        isMultiple
                        placeholder="Select authorized users.."
                        allUsers
                        customStyle={{
                          border: '1px solid rgba(68, 130, 218, 0.2)',
                          borderRadius: '4px',
                          width: '98%',
                          fontSize: '13px',
                          marginBottom: '10px',
                        }}
                      />
                      {(formSubmitted && !(moUsers?.length > 0)) && (
                        <div className="input-error">
                          *Please select manufacturing order users
                        </div>
                      )}
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
        <Table
          bordered
          showHeader
          title={() => `Items to be Produced(${moLines?.filter((item) => item?.selectedBom)?.length})`}
          size="small"
          columns={getTableColumns()?.filter((i) => !i?.hidden)}
          dataSource={moLines}
          pagination={false}
          loading={convertSoToMoLoading || getSKUAvailabilityLoading}
          scroll={{ x: 'max-content' }}
          rowClassName={(record) => (!record?.bomList?.length ? 'so-mo-table__disabled-row' : '')}
        />
        <div className="custom-drawer__footer" style={{ display: 'flex', width: '975px' }}>
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Submit"
            onClick={() => onSubmit()}
            isLoading={convertSoToMoLoading}
            disabled={convertSoToMoLoading || getSKUAvailabilityLoading || !manufacturingOrder}
            style={{
              width: '160px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
          {!manufacturingOrder && (
            <Popconfirm
              placement="topRight"
              title="This feature is not available in your current plan"
              onConfirm={() => window.Intercom('showNewMessage')}
              okText="Contact Us"
              cancelText="Cancel"
            >
              <img
                className="barcode-restrict"
                src={Crown}
                alt="premium"
                style={{
                  marginLeft: '8px',
                  marginTop: '5px',
                }}
              />
            </Popconfirm>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, CartReducers, SOReducers,
}) => ({
  user: UserReducers.user,
  convertSoToMoLoading: SOReducers.convertSoToMoLoading,
  getSKUAvailabilityLoading: CartReducers.getSKUAvailabilityLoading,
});

const mapDispatchToProps = (dispatch) => ({
  convertSoToMo: (payload, callback) => dispatch(SoActions.convertSoToMo(payload, callback)),
  getSKUAvailability: (payload, callback) => dispatch(CartActions.getSKUAvailability(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ConvertCartToMo));
